import { useCallback, useEffect, useState } from "react"

import { useLazyGetCustomersAppsTrendQuery } from "store/api/widgetsApi"

import { DEFAULT_PERIOD, TrendCard } from "./TrendCard"
import { computeTrend } from "./useTrendData"

export const CustomersAppsCard = () => {
  const [period, setPeriod] = useState(DEFAULT_PERIOD)
  const [trigger, { data }] = useLazyGetCustomersAppsTrendQuery()

  useEffect(() => {
    trigger({ period })
  }, [period, trigger])

  const clients = computeTrend(data?.data?.clients, period)
  const mobileApps = computeTrend(data?.data?.mobile_app_clients, period)

  const handlePeriodChange = useCallback((newPeriod: number) => {
    setPeriod(newPeriod)
  }, [])

  return (
    <TrendCard
      title="Customers & Apps"
      onPeriodChange={handlePeriodChange}
      columns={[
        {
          label: "Active Customers",
          value: clients.value,
          tooltip: "Active customers in the selected period",
          tooltipPeriod: {
            period,
            lastPeriodCount: clients.lastPeriodCount,
            prevPeriodCount: clients.prevPeriodCount,
            unit: "customers",
          },
          trend: clients.trend,
          chart: clients.chart,
        },
        {
          label: "With Mobile App",
          value: mobileApps.value,
          tooltip: "Customers using the mobile app",
          tooltipPeriod: {
            period,
            lastPeriodCount: mobileApps.lastPeriodCount,
            prevPeriodCount: mobileApps.prevPeriodCount,
            unit: "customers",
          },
          trend: mobileApps.trend,
          chart: mobileApps.chart,
        },
      ]}
    />
  )
}
